import React from "react";

function SecuritizationHero() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover"
        style={{
          background:
            "url(assets/img/bg/white_label_crypto_exchange_image.jpg)",
        }}
      >
        <div className="container">
          <div className="row align-center">
            <div className="col-xl-7 col-lg-8">
              <div className="banner-two-content">
                <h2 className="split-text-right split-text-in-right">
                  Empowering Your Security Token Offering with End-to-End
                  Solutions
                </h2>
                <div className="info">
                  <p className="fade-up-anim">
                    Transforming traditional assets into secure, compliant
                    digital securities for the modern investor.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SecuritizationHero;
